import verifiedBadge from '@/assets/verified-badge.png'
import { BadgeResponse } from '@/types'

/**
 * Icon urn stamped on the verified badge's definition in every environment's
 * catalog (admin-editable, no deploy needed). The primary identity check:
 * badge urns are environment-specific admin-minted ids, but the iconUrn names
 * the *rendering* — exactly what the client needs to know.
 */
export const VERIFIED_BADGE_ICON_URN = 'urn:dupr:icon:badge:verified'

/**
 * The "DUPR Verified" badge's catalog urn. Fallback match for payloads that
 * carry bare urn strings (older backends) — those have no iconUrn to check.
 *
 * Note(badges): this is the admin-minted urn (mirrors mobile_RN). Once the
 * server promotes the code-defined badge, switch this to the
 * environment-stable `urn:dupr:badge:verified:v1`.
 */
export const VERIFIED_BADGE_URN = 'urn:dupr:badge:1602bd4b-0112-4036-8a3b-26317b5cf141'

/** Accessibility label for the verified badge mark. */
const VERIFIED_BADGE_LABEL = 'DUPR Verified'

/** Whether one wire badge entry is the verified badge. */
function isVerifiedBadge(badge: string | BadgeResponse): boolean {
  if (typeof badge === 'string') return badge === VERIFIED_BADGE_URN
  return badge.iconUrn === VERIFIED_BADGE_ICON_URN || badge.urn === VERIFIED_BADGE_URN
}

/**
 * Whether a wire badge list contains the verified badge. Badge objects are
 * matched by iconUrn (environment-stable); bare urn strings — the shape
 * search/list payloads send — can only match the urn.
 */
export function hasVerifiedBadge(badges: ReadonlyArray<string | BadgeResponse> | undefined | null): boolean {
  if (!badges) return false
  return badges.some(isVerifiedBadge)
}

/** Blue verified rosette, sized to sit inline beside a player name. */
export const VerifiedBadge = ({ className = 'w-3.5 h-3.5' }: { className?: string }) => {
  return <img src={verifiedBadge} alt={VERIFIED_BADGE_LABEL} className={`inline-block shrink-0 ${className}`} />
}
